module.exports = __webpack_public_path__ + "img/logos_partner_18.89bc8e78.svg";